import Trans from '../translations/trans';
import useDateFormat from '../../hooks/useDateFormat';

export default function TermsAndConditions({ terms, campaignEnd, promoCode }) {
    const formattedCampaignEnd = useDateFormat(campaignEnd, 'time.endDateFormat');

    return (
        <div className='wrapper arc3-padding'>
            <h4 className='terms-title arc3-margin--right-lger arc3-margin--left-lger'>
                <Trans transKey='discountOverview.termsAndConditions.title' />
            </h4>

            {/* @TODO campaignEnd to takeinto account any campaign extensions/fake campaignEnds */}
            <p className='terms-content arc3-margin--right-lger arc3-margin--left-lger'>
                {terms.replace('{campaign-expiry}', formattedCampaignEnd).replace('{promocode}', promoCode)}
            </p>
        </div>
    );
}
